export default "__VITE_ASSET__fabf82bc__"